import { DateUtils } from '@brunommsilva/react-foundations';
import { SimpleCard } from '@brunommsilva/react-foundations';
import { useTheme } from '@brunommsilva/react-foundations';
import { Box, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Balance } from '../../models/balances/balance-history';
import LineChart from '../charts/line-chart';

interface Props {
  balances: Balance[];
  isLoading: boolean;
}

const BalanceHistoryChart = ({ balances, isLoading }: Props) => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  const renderBalances = () => {
    if (isLoading) {
      return (
        <Box sx={{ height: 400, width: '100%', p: 2 }}>
          <Skeleton variant="rounded" width="100%" height="100%" />
        </Box>
      );
    }

    const months = balances.map((balance) =>
      DateUtils.formatMonth(balance.month, 'short')
    );
    const amounts = balances.map((balance) => balance.amount);

    // A line at the start of each year, with the year, to tell them apart.
    const yearMarks = balances.flatMap(({ month }, index) =>
      month.endsWith('-01') ? [{ index, label: month.slice(0, 4) }] : []
    );

    const values = [
      {
        label: t('TOTAL_BALANCE'),
        values: amounts,
        colors: [theme.palette.primary.main],
        fill: true,
      },
    ];

    return (
      <Box sx={{ height: 400, width: '100%' }}>
        <LineChart labels={months} series={values} axisMarks={yearMarks} />
      </Box>
    );
  };

  return (
    <SimpleCard
      title={t('BALANCE_HISTORY_CARD_TITLE')}
      content={renderBalances()}
    />
  );
};

export default BalanceHistoryChart;
